<template>
  <div class="advertisementVertical" v-if="subjectType != 'ACTOR' && option.length != 0" :style="{top:top,left:left,right:right,bottom:bottom,width:width}">
    <template>
      <div class="advertisement-to-banner" v-if="option.length <= 1">
        <a @click="openUrl(option[0])"><img :src="option[0]['img']"/></a>
      </div>
      <div class="advertisement-to-banner" v-else>
        <swiper :options="swiperOption" class="swiper-container-topBanner">
          <swiper-slide class="swiper-slide-topBanner" v-for="(item, index) in option" :key="index">
            <a  @click="openUrl(item)"><img :src="item.img"/></a>
          </swiper-slide>
        </swiper>
      </div>
    </template>
  </div>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  props: {
    option: {
      type: [Object, String, Array],
      default: () => ''
    },
    leftPosition: {
      type: Boolean,
      default: false
    },
    top: {
      type: [Object, String, Array],
      default: () => ''
    },
    rightPosition: {
      type: Boolean,
      default: false
    },
    bottom: {
      type: [Object, String, Array],
      default: () => ''
    }
    
  },
  components: {},
  data() {
    return {
      swiperOption: {
        slidesPerView: 'auto',
        loop: false,
        autoplay: {
          disableOnInteraction: false,
          delay: 3000
        }
      },
      left: 'auto',
      right: 'auto',
      width: 0
    }
  },
  computed: {
    ...mapGetters(['language', 'subjectType'])
  },
  created() {
    const changeAdvertisementWidth = () => {
      const position = this.$funcs.calcAdvertisementWidth()
      this.leftPosition && (this.left = position.left + 'px')
      this.rightPosition && (this.right = position.right + 'px')
      this.width = position.width + 'px'
    }
    const throttle = this.$funcs.throttle(changeAdvertisementWidth, 300)
    throttle()
    window.addEventListener('resize', throttle, false)
    this.$once('hook:beforeDestroy', () => {
      window.removeEventListener('resize', throttle)
    })
  },
  mounted() {},
  methods: {
    goLogin(){
      if (this.subjectType == '') {
        this.$store.commit('SET_SUBJECTTYPE', '')
        this.loginSource('/login/person')
      }
    },
    openUrl(data) {
      if (data.id) {
        if(data.type == 'actor') {
          this.openNewPage(`/find-exhibitor/detail/${data.id}`)
        } else if (data.type == 'product') {
          this.openNewPage(`/find-exhibit/detail/${data.id}`)
        }
      }
      
    }
  }
}
</script>

<style lang="stylus" scoped>
.advertisementVertical{
  position fixed
  z-index 2000
  width 200px
  // height 550px
  img{
    width 100%
    height 100%
    object-fit cover
  }
}
.swiper-container-topBanner{
  background  $color-black-25;
}

</style>
